import { AntCard as Card } from "@murm/ant";
import { categoryIcon, categoryLabel } from "../config/catalogContent";
import styles from "../DataCatalog.module.css";
import { PENDO_ID, pendoId } from "../../../lib/pendoIds";

/** Top-level category card: small Ant icon above the label (Explorer Figma, 2a / 2c). */
export const CategoryButton = ({ category, onClick }) => {
  const icon = categoryIcon(category);
  return (
    <Card
      {...pendoId(PENDO_ID.CATALOG_CATEGORY)}
      hoverable
      onClick={onClick}
      className={styles.card}
      classNames={{ body: styles.categoryBody }}
    >
      {icon && <div className={styles.categoryIcon}>{icon}</div>}
      <span className={styles.cardLabel}>{categoryLabel(category)}</span>
    </Card>
  );
};
